<template>
  <div class="treeContainer" v-if="visible">
    <vue-draggable-resizable drag-handle=".ant-card-head" class="wrap dy3dDialog" :w="dragW" :h="dragH">
      <a-card 
        class="collect-card"
        title='统计信息'>

        <img style="width:16px;cursor: pointer;" :src="require('@/assets/images/closeIcon.png')" slot="extra" @click="handleClose"/>

        <div class='tools'>
          <a-input-search
            class="inputSearch"
            v-model="searchVal"
            placeholder="请输入检索关键词"
            :allowClear="true"
            @search="onSearch"
          />
          <img :src="require('@/assets/images/tableIcon.png')" title='表格展示' alt="" @click="showTable" style="cursor:pointer">
        </div>

        <div @contextmenu.stop style="height:88%; overflow:auto">
          <a-tree
              class="tree"
              :tree-data="fileArr"
              :replaceFields="replaceFields"
              :expanded-keys="expandedKeys"
              show-icon
              @select='selectNode'
              @expand="onExpand"
            >
            <!-- 文件夹节点前面的图标 -->
            <img slot="group" :src="require('@/assets/images/folderIcon.png')" />
            <!-- 数据节点前面的图标 -->
            <img slot="file" :src="require('@/assets/images/fileIcon.png')" />
          </a-tree>
        </div>
      </a-card>
    </vue-draggable-resizable>
    <mars-modal ref="marsModal"></mars-modal>
  </div>
</template>

<script>
  import MarsModal from '../../../components/hzfxMarsModel.vue'
  import { queryGeomByAttr } from "../../../../utils/queryGeomByAttr.js";
  export default {
    name:'staticInfoTreeDialog',
    components: {
      MarsModal,
    },
    data() {
      return {
        dragW: 340,
        dragH: 700,
        visible:false,  // 图层管理的弹框
        searchVal:'',
        layerAlias:'',  // 选择的图层的别名
        tableData:[], // 父组件传来的表格数据
        fileArr:[],  // 树结构数据
        defaultData:[],  // 树结构数据（备份）
        replaceFields:{
          children: 'children',
          title: 'title',
          key: 'bsm',
        },
        expandedKeys:[],
        flAttrs:[],  // 统计信息表格 表头分类字段的属性名  例如——['xzqdm','xzqmc','dlbm']
        parentInfo:null, // 父组件传来的信息
        geoserverUrl:''
      }
    },
    methods: {
      /** 
       * 打开树组件
       * @param {object} msg  统计信息表格的信息
       * @param {arr} flHeaders  统计信息表格 表头分类字段的属性名  例如——['xzqdm','xzqmc','dlbm']
       */
      open(msg,flHeaders,geoserverUrl){
        console.log('统计信息数据',msg,flHeaders);
        this.flAttrs = flHeaders
        this.fileArr = []
        // 统计信息表格数据
        this.tableData = msg.data
        this.layerAlias = msg.alias ? msg.alias : ''
        this.geoserverUrl = geoserverUrl
        let bsm = 0

        this.tableData.map((item,index) => {
          // 按照表头的顺序，把每一行的值过滤出来 例如——['320100','南京市','0101']
          let keys = flHeaders.map(prop => item[prop])
          let currentLevel = this.fileArr;
          keys.map((key,i) => {
            if(key && key != '小计' && key != '合计'){
              const existingNode = currentLevel.find(node => node.title === key);
  
              if (!existingNode) {
                // 创建新的节点
                const newNode = { title: key, bsm: bsm++, children: [] };
                // 将 newNode 添加到当前层级的数组 currentLevel 中。newNode 就是当前层级的一个子节点
                currentLevel.push(newNode);
                // 将 currentLevel 更新为新节点 newNode 的 children 数组(如果没有上一步，新节点 newNode 不会被添加到当前层级的数组中，而是直接替换当前层级的数组为新节点的 children 数组)
                currentLevel = newNode.children;
              } else {
                currentLevel = existingNode.children;
              }
  
              // 添加最后一个节点
              if (i === keys.length - 2) {
                let title = item[flHeaders[flHeaders.length - 1]]
                if(title != '小计' && title != '合计'){
                  currentLevel.push({ title: title, bsm:bsm++ });
                }
              }
            }
          })
        })
        // 暂时用不到parentBsm
        // this.fileArr.map(item => {
        //   this.addParentBsmToTree(item,null)
        // })
        console.log('fileArr',this.fileArr);
        this.defaultData = JSON.parse(JSON.stringify(this.fileArr))
        this.visible = true
      },
      // 遍历树节点，添加parentBsm
      addParentBsmToTree(node, parentBsm) {
        if (node) {
          node.parentBsm = parentBsm;
          // 递归遍历子节点
          if (node.children && node.children.length > 0) {
            for (const childNode of node.children) {
              this.addParentBsmToTree(childNode, node.bsm); // 传递当前节点的 bsm 作为父节点的 bsm
            }
          }
        }
      },
      // 树结果搜索功能
      onSearch() {
        if (this.searchVal) {
          this.fileArr = []
          this.matchNodes(this.defaultData)
        } else {
          this.fileArr = this.defaultData
        }
      },
      matchNodes(data){
        for(let i = 0; i < data.length; i++){
          if(data[i].title.indexOf(this.searchVal) > -1){
            this.fileArr.push(data[i])
          }else{
            if(data[i].children && data[i].children.length > 0){
              this.matchNodes(data[i].children)
            }
          }
        }
      },
      // 点击节点
      selectNode(selectedKeys,e){
        let selectNode = e.node.$vnode.data.props.dataRef
        console.log('点击节点',selectedKeys,selectNode);
        let parentNodeTitles = []
        this.findAllParentNode(this.fileArr, selectNode, parentNodeTitles)  
        // 由于parentNodeTitles拿到的是所有父节点的名称，需要组装成键值对
        let resultObject = {}
        resultObject.value = this.flAttrs.reduce((result, key, index) => {
          if(parentNodeTitles[index]){
            result[key] = parentNodeTitles[index];
          }
          return result;
        }, {});
        resultObject.alias = this.layerAlias
        resultObject.geoserverUrl = this.geoserverUrl
        console.log('找到父节点',resultObject);
        this.$emit('showDetailsByAttr',resultObject)
        // this.showDetailsByAttr(resultObject)
      },
      // 点击单元格查询绘制范围内所有符合条件的图斑
      showDetailsByAttr(targetObj){
        const _this = this
        let geoLayer = this.map.getLayerByAttr('查询结果','name')
        if(geoLayer){
          this.map.removeLayer(geoLayer)
        }
        this.geoJsonLayer = new mars3d.layer.GeoJsonLayer({
          name: '查询结果',
          symbol: {
            type: 'polygonP', //面
            styleOptions: {
              color: "#3388ff",
              opacity: 0.3,
              outline: true,
              outlineWidth: 2,
              outlineColor: "#3388ff",
              clampToGround: true, //贴地
              highlight: {
                type:'click',
                color: '#ffcc00',
                outline: true,
                outlineColor: '#64ff44',
              },
            },
          },
          flyTo:true
        })
        this.map.addLayer(this.geoJsonLayer)

        //移除总的分析图层
        let aliveLayer = this.map.getLayerByAttr('查询分析图层','name')
        if(aliveLayer){
          this.map.removeLayer(aliveLayer)
        }

        let geom
        // 如果是选择多个多边形需要用bsm区分然后传入参数进行查询
        if(this.fwArry.length > 1){
          if(this.fwArry[0].analysisType){
            geom = this.fwArry.find(item=>item.bsm == this.activeTab).bufferLayer
          }else{
            geom = this.fwArry.find(item=>item.bsm == this.activeTab)
          }
        }else if(this.fwArry.length == 1){
          if(this.fwArry[0].analysisType){
            geom = this.fwArry[0].bufferLayer;
          }else{
            geom = this.fwArry[0];
          }
        }

        console.log(geom);
        // 如果为空，不进行继续分析
        if(!geom){
          return
        }

        queryGeomByAttr(targetObj.geoserverUrl,targetObj.alias,targetObj.value,geom).then(res=>{
          _this.geoJsonLayer.load({data: res.geojson})
        })
        this.geoJsonLayer.on(mars3d.EventType.click,function(event) {
          // 属性
          let attributes = []
          let detailInfo = event.graphic.options.attr
          if(_this.dialogTitle == '专题分析'){
            attributes = _this.layerLists.filter(e => e.alias.split(':')[1].indexOf(record.tcmc) > -1 )[0].attributes
          }else{
            attributes = _this.layerData.attributes
          }
          _this.$refs.marsModal.showModal(detailInfo, '详情查看', attributes)
        })
      },
      // 点击节点，找到它所有的父节点
      findAllParentNode(data, target, result) {
        for (let item of data) {
          if (item.bsm === target.bsm) {
            //将查找到的目标数据加入结果数组中
            result.unshift(item.title)
            return true
          }
          if (item.children && item.children.length > 0) {
            //根据查找到的结果往上找父级节点
            let isFind = this.findAllParentNode(item.children, target, result)
            if (isFind) {
              result.unshift(item.title)
              return true
            }
          }
        }
        //走到这说明没找到目标
        return false
      },
      // 展开选项
      onExpand(expandedKeys) {
        this.expandedKeys = expandedKeys
      },
      // 以表格形式展示
      showTable(){
        this.handleClose()
        this.$emit('showTable')
      },
      // 关闭页面
      handleClose() {
        this.visible = false
      },
    },
  }
</script>

<style lang="less" scoped>
.treeContainer {
  width: 340px;
  height: calc(100% - 100px);
  position: absolute;
  top: 60px;
  left: 20px;
  .wrap {
    z-index: 1000 !important;
    width: 100% !important;
    height: 100% !important;
  }
  .collect-card {
    width: 100%;
    height: 100%;
    .tools {
      display:flex;
      justify-content: space-between;
      align-items: center; 
      width:100%;
      .inputSearch {
        width: 60%;
      }
    }
  }
  /deep/.ant-card-head-title {
    color: #fff;
    padding: 0;
  }
  /deep/ .ant-card {
    backdrop-filter: blur(15px);
    border: 0;
    .ant-input{
      background: rgba(255, 255, 255, 0.10) !important;
      border: 1px solid rgba(255, 255, 255, 0.50);
      &::placeholder {
        color: rgba(255, 255, 255, 0.30);
        font-size: 12px;
      }
    }
  }
  /deep/ .ant-card-head {
    padding: 0 10px;
    width: 96%;
    min-height: 0px;
    height: 5%;
    display: flex;
    margin: auto;
    border-bottom: 1px solid rgba(255, 255, 255, 0.20);
    &:hover {
      cursor:move;
    }
  }

  /deep/ .ant-card .ant-card-body > div {
    &:nth-child(1) {
      height: 5%;
      width: 100%;
      /deep/ .ant-input-affix-wrapper {
        position: relative;
        /deep/ .ant-input-suffix {
          position: absolute;
          left: 80%;
        }
      }
    }
    &:nth-child(2) {
      height: 95% !important;
      background: none;
      & > ul {
        height: 100%;
      }
    }
  }
  
  /deep/ .ant-card-body {
    width: 100%;
    padding: 10px;
    height: 95%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  /deep/ .ant-card-head-wrapper {
    width:100%;
    background: transparent !important;
  }
}
</style>